import { useContext } from 'react';
import { ServiceLetterContext } from '../contexts/ServiceLetterContext';

export const useServiceLetterContext = () => {
    return useContext(ServiceLetterContext);
};
